import type { FC, SVGProps } from "react";

const UnFullscreenIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="UnFullscreen icon">
      {/* <title>UnFullscreen icon</title> */}
      <path
        d="M9.25705 3.77133C9.25705 3.01276 8.64419 2.3999 7.88562 2.3999C7.12705 2.3999 6.51419 3.01276 6.51419 3.77133V6.51419H3.77133C3.01276 6.51419 2.3999 7.12705 2.3999 7.88562C2.3999 8.64419 3.01276 9.25705 3.77133 9.25705H7.88562C8.64419 9.25705 9.25705 8.64419 9.25705 7.88562V3.77133ZM3.77133 14.7428C3.01276 14.7428 2.3999 15.3556 2.3999 16.1142C2.3999 16.8728 3.01276 17.4856 3.77133 17.4856H6.51419V20.2285C6.51419 20.987 7.12705 21.5999 7.88562 21.5999C8.64419 21.5999 9.25705 20.987 9.25705 20.2285V16.1142C9.25705 15.3556 8.64419 14.7428 7.88562 14.7428H3.77133ZM17.4856 3.77133C17.4856 3.01276 16.8728 2.3999 16.1142 2.3999C15.3556 2.3999 14.7428 3.01276 14.7428 3.77133V7.88562C14.7428 8.64419 15.3556 9.25705 16.1142 9.25705H20.2285C20.987 9.25705 21.5999 8.64419 21.5999 7.88562C21.5999 7.12705 20.987 6.51419 20.2285 6.51419H17.4856V3.77133ZM16.1142 14.7428C15.3556 14.7428 14.7428 15.3556 14.7428 16.1142V20.2285C14.7428 20.987 15.3556 21.5999 16.1142 21.5999C16.8728 21.5999 17.4856 20.987 17.4856 20.2285V17.4856H20.2285C20.987 17.4856 21.5999 16.8728 21.5999 16.1142C21.5999 15.3556 20.987 14.7428 20.2285 14.7428H16.1142Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default UnFullscreenIcon;
